import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../EditorLoadableWrapper';
import retry from '../../../utils/chunkRetry';
const LoadableEditor = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "editor_v3", webpackPrefetch: true */ './Comment')));
const CommentEditorLoadable = (_param)=>{
    var { loadingIndicator } = _param, rest = _object_without_properties(_param, [
        "loadingIndicator"
    ]);
    return /*#__PURE__*/ React.createElement(EditorLoadableWrapper, {
        fallback: loadingIndicator
    }, /*#__PURE__*/ React.createElement(LoadableEditor, rest));
};
CommentEditorLoadable.displayName = 'CommentEditor';
export default CommentEditorLoadable;

//# sourceMappingURL=CommentLoadable.js.map